import { useMutation } from '@tanstack/react-query';
import { remakePractice } from '../queries/post';

export function useCreatePracticeRemake() {
  const { mutate, data } = useMutation({
    mutationKey: ['createPracticeRemake'], 
    mutationFn: (id: string) => remakePractice(id),
    retry: false
  });

  return { mutate, data };
}
